import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jjgu425ts: FaireProductEntity = {
  token: "p_5jjgu425ts",
  type: "product",
  name: "Where's the Christmas Poo?",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/563b9938d06f7daedad99f7e9e76145302686f303ed7dcc3c50a6b4b9dd145c3.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "It's beginning to smell a lot like Christmas!\n\nRudy the Reindeer Poo and his festive friends are on an adventure to drop off all their Christmas deliveries. But ho, oh no! They keep getting lost... can you find them?\n\nThe perfect stocking-filler, this Christmas activity book comes from the bestselling creator of 'Where's the Poo?'",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:41.852Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
